import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const BacklitPosters = () => {

  const servicesFaqData = [
    {
        question: "What are backlit posters, and where can they be used?",
        answer: "Backlit posters are high-resolution prints designed to be displayed in lightboxes or illuminated signage. They use translucent materials that allow light to pass through, enhancing the vibrancy of colours and details. These posters are commonly used in retail stores, airports, exhibitions, and cinemas for advertising and branding purposes. Backlit posters create a professional and eye-catching effect, especially in low-light environments. Their ability to attract attention makes them a valuable tool for promotional campaigns and corporate branding."
    },
    {
        question: "What are the benefits of custom backlit poster printing?",
        answer: "Custom backlit poster printing allows businesses to create personalised designs tailored to their branding and messaging needs. These posters offer superior visibility due to their illuminated displays, ensuring your message stands out in crowded spaces. High-quality printing enhances the colour vibrancy and sharpness of the visuals, making them ideal for impactful advertising. Customisation options, such as size and material, ensure the posters fit specific lightboxes or display areas. With durable materials and fade-resistant inks, custom backlit posters provide long-lasting promotional solutions."
    },
    {
        question: "Can Printingy handle bulk orders for backlit poster printing?",
        answer: "Yes, Printingy specialises in bulk backlit poster printing, ensuring cost-effective solutions for large-scale orders. Our advanced printing technology guarantees consistent quality across all prints, regardless of order size. Bulk orders are ideal for businesses with multiple locations or extensive promotional campaigns. We prioritise efficiency, ensuring that large volumes are completed within the agreed timeframe without compromising quality. Printingy is a trusted partner for businesses looking to scale their advertising efforts with vibrant and professional backlit posters."
    },
    {
        question: "What materials are used for backlit film printing?",
        answer: "Backlit film printing uses translucent materials such as polyester or specialised backlit film. These materials are designed to diffuse light evenly, creating vibrant and sharp visuals when illuminated. The film is lightweight yet durable, making it suitable for indoor and outdoor displays. High-quality UV-resistant inks ensure long-lasting colours and prevent fading over time. Our advanced printing process guarantees precision and clarity, providing a professional finish for all backlit displays."
    },
    {
        question: "What industries benefit from backlit poster printing services?",
        answer: "Retail, hospitality, entertainment, and transportation industries greatly benefit from backlit poster printing services. Retailers use backlit posters for in-store promotions and window displays. Cinemas and entertainment venues rely on them for movie posters and event advertising. Hospitality businesses use backlit displays for menu boards and promotional signage. Transportation hubs like airports and metro stations use backlit posters for wayfinding and advertisements. The versatility and visual appeal of backlit posters make them a valuable asset for various industries."
    }
  ];


const [pageTitle, setPageTitle] = useState('Printing of Backlit Posters');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes



  return (
    <div>
    <MetaManager 
  title="Custom Backlit Poster Printing Services"
  description="High-quality printing of backlit posters for vibrant displays. Bulk custom backlit poster printing, backlit film printing, and backlit photo printing solutions."
  keywords="Printing of Backlit Poster,
Backlit Poster Printing,
Custom Backlit Poster Printing,
Backlit Film Printing,
Backlit Photo Printing"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Backlit Posters</h1>
              <h2 className="text-muted">
              Custom backlit posters for vibrant and eye-catching displays
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Backlit posters are the perfect solution for creating vivid, illuminated displays that capture attention in indoor and outdoor settings. Printingy specialises in Printing Backlit Posters, delivering high-quality backlit poster printing solutions for businesses and events.</p>
          <p>Our services include custom backlit poster printing for tailored designs and branding needs. We offer backlit film printing with sharp graphics and vibrant colours for illuminated signage. Our backlit photo printing also ensures high-resolution visuals that create a stunning impact in lightbox displays.</p>
          <p>Whether for retail environments, exhibitions, or advertising campaigns, Printingy provides bulk printing solutions that ensure precision, durability, and cost-effectiveness.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Backlit Poster Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and vibrant posters for illuminated displays</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Backlit Posters for impactful branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk backlit poster printing at competitive rates for large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised custom backlit poster printing tailored to your needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional backlit film printing for illuminated signage.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution backlit photo printing for vivid and sharp visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials and fade-resistant inks for long-term use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for retailers, event organisers, and corporate displays.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/backlitposters.jpg" // Path relative to the public folder
                  alt="Professional printing of backlit posters services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Backlit Posters Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your backlit poster printing needs</h3>
            <p>Printingy uses advanced technology and premium materials to deliver exceptional backlit poster printing solutions. Our services ensure vibrant colours, sharp graphics, and durable materials for long-lasting illuminated displays.</p>
            <p>Whether you need custom backlit poster printing for a trade show or backlit photo printing for a retail environment, we guarantee precision and consistency. Our streamlined processes ensure timely delivery, making Printingy your reliable partner for impactful backlit posters.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default BacklitPosters;
